import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CfsTemplate } from "@app/models";
import { TemplateAnimationType } from "clearline-common";

@Component({
  selector: "app-printable-template",
  templateUrl: "./printable-template.component.html",
  styleUrls: ["./printable-template.component.scss"]
})
export class PrintableTemplateComponent {
  @Input() template: CfsTemplate;

  @Output() print = new EventEmitter();

  readonly TemplateAnimationType = TemplateAnimationType;

  private readyToPrintTemplateCount = 0;

  onPrint(): void {
    this.readyToPrintTemplateCount += 1;

    if (this.readyToPrintTemplateCount === 1) {
      setTimeout(() => {
        this.print.emit();
      }, 0);
    }
  }
}
